import { put, select } from 'redux-saga/effects';
import { Registerer, RegistererState } from 'sip.js';

// import { log } from 'loglevel';
import {
  setRegisterer, selectUA, setUA, setUAState,
  incReconnectionAttempt,
  selectRegisterer,
} from '../../../state/ua/uaSlice';
import { attemptReconnectAction } from '../attemptReconnect/action';
// import { logoutAction } from '../../logout/action';
import store from '../../../state/store';
import bugsnagClient from '../../../services/bugsnag/bugsnag';
import { handleUAUnAuthorizedAction } from '../handleUAUnAuthorized/action';

let registrationTimeoutTimer = null;

export default function* addRegistrar() {
  const ua = yield select(selectUA);

  try {
    let registerer = yield select(selectRegisterer);
    if (!registerer || registerer.state === RegistererState.Terminated) {
      registerer = new Registerer(ua);
      yield put(setRegisterer(registerer));

      registerer.stateChange.addListener((newState) => {
        switch (newState) {
          case RegistererState.Initial:
            store.dispatch(setUAState('init'));
            break;
          case RegistererState.Registered:
            if (registrationTimeoutTimer) {
              clearTimeout(registrationTimeoutTimer);
              registrationTimeoutTimer = null;
            }
            store.dispatch(setUAState('registered'));
            break;
          case RegistererState.Terminated:
            store.dispatch(setUAState('closed'));
            break;
          case RegistererState.Unregistered:
            if (!registrationTimeoutTimer) {
              registrationTimeoutTimer = setTimeout(() => {
                ua.stop().then(() => {
                  store.dispatch(attemptReconnectAction());
                });
                registrationTimeoutTimer = null;
              }, 3000);
            }
            store.dispatch(setUAState('unregistered'));
            break;
          default:
        }
      });
    }

    console.debug('pre-register registerer state:', registerer.state);
    try {
      yield registerer.register({
        requestDelegate: {
          onReject(response) {
            console.debug('register onReject:', response);
            if (response.message.statusCode === 503 || response.message.statusCode === 500) {
              store.dispatch(incReconnectionAttempt());
            } else if (response.message.statusCode === 401) {
              // Handle authentication failure
              console.debug('Authentication failed, re-registering with updated credentials');
              // store.dispatch(attemptReconnectAction());
              // TODO: reCheck WPdevice credentials, if password has changed, logout.
              //        Other possibilities are to keep WP up, but have UA disconnected.
              ua.stop();
              store.dispatch(setRegisterer(null)); // Dispatch action to update the state
              store.dispatch(setUA(null)); // Dispatch action to update the state
              store.dispatch(handleUAUnAuthorizedAction());
              // store.dispatch(logoutAction());
            }
          },
        },
      });
    } catch (e) {
      console.debug(e); // eslint-disable-line no-console
    }
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error('Failed to Register', e);
    bugsnagClient.notify(e);
    yield put(setUA(null));
    yield put(setRegisterer(null));
    yield put(attemptReconnectAction());
  }
}
